import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2 text-center">
          核心优势
        </h2>
        <p className="text-sm text-foreground-500 mb-10 text-center">为什么选择吃瓜51</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-200 text-center group"
            >
              <span className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl mx-auto mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-primary-600 text-xl`}></i>
              </span>
              <h3 className="text-sm font-bold text-foreground-950 font-heading mb-2">
                {feature.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}